import { Components } from '@mui/material';
import { Theme } from '@mui/material/styles';

import { black, primaryColors, white } from './styles/colors';
import { defaultBorder } from './styles/mixins';

const MuiTextField: Components<Omit<Theme, 'components'>>['MuiTextField'] = {
  styleOverrides: {
    root: {
      background: black['15%'],
      boxShadow: '0px 1px 2px rgba(0, 0, 0, 0.07)',
      borderRadius: '6px',

      '& input[type=number]': {
        MozAppearance: 'textfield',
      },
      '& input[type=number]::-webkit-outer-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
      },
      '& input[type=number]::-webkit-inner-spin-button': {
        WebkitAppearance: 'none',
        margin: 0,
      },
      '.MuiInputLabel-root': {
        color: primaryColors[200],
        fontFamily: 'Space Grotesk',
        fontStyle: 'normal',
        fontWeight: '300',
        fontSize: '14px',
        lineHeight: '22px',
        '.Mui-focused': {
          color: primaryColors[200],
        },
        WebkitAppearance: 'none',
        margin: 0,
        MozAppearance: 'textfield',
      },
      'label.Mui-focused, label.Mui-error': {
        color: primaryColors[200],
      },
      '.MuiInputLabel-shrink': {
        color: primaryColors[200],
        transform: 'translate(12px, 10px)',
        fontWeight: 700,
        lineHeight: '12px',
        fontSize: '10px',
        letterSpacing: '1px',
        textTransform: 'uppercase',
      },
      '.MuiInputBase-root': {
        color: primaryColors[100],
        padding: '16px 12px',
      },
      '.MuiInputBase-input': {
        padding: 0,
        fontFamily: 'Space Grotesk',
        fontStyle: 'normal',
        fontWeight: '300',
        fontSize: '14px',
        lineHeight: '22px',
      },
      '.Mui-focused': {
        input: {
          outline: 'none',
        },
      },
      '.Mui-disabled': {
        color: white['15%'],
      },
      ...defaultBorder,
    },
  },
};

export default MuiTextField;
